import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { HelpPostCard } from './cards/help-post-card.component';

import { HelpPost } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_types/help-post.type';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

interface MostAccessedSectionProps {
  helpPosts: HelpPost[];
}

export const MostAccessedSection = ({ helpPosts }: MostAccessedSectionProps) => {
  if (helpPosts.length === 0) {
    return null;
  }

  return (
    <section
      className="flex flex-col w-full pt-6 xl:pt-10"
      data-testid={DataTestIdEnum.FAQ_MOST_ACCESSED_SECTION}
    >
      <Typography
        variant={TypographyVariant.MEDIUM_SUBTITLE}
        as="h2"
        className="font-bold text-gray-900 mb-4 lg:mb-6"
      >
        Dúvidas mais acessadas
      </Typography>
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
        {helpPosts.map((post) => (
          <HelpPostCard key={post.slug} post={post} />
        ))}
      </div>
    </section>
  );
};
